const truthyEnvValues = new Set(['1', 'true', 'yes', 'on']);

const parseBooleanEnv = (value, fallback = false) => {
  if (typeof value !== 'string') {
    return fallback;
  }

  return truthyEnvValues.has(value.trim().toLowerCase());
};

export const PRINT_FULL_RESUME = parseBooleanEnv(
  process.env.REACT_APP_PRINT_FULL_RESUME
);
